import React from 'react';
function Forbidden() {
    return <h1>Zabranjeno. Nemate pristup ovoj stranici!</h1>;
  }

export default Forbidden;
